// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3xSDF","buttons":"PendingPaymentAlert_buttons__hep7H"};